import React from "react";
import {useSiteStructureTypeQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SiteStructureTypeSelect = (props) => {
    const query = useSiteStructureTypeQueryQuery();
    return <GraphQlSelect queryResult={query} {...props} labelField="name" />;
}
